import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { getSelectedAssessmentSelector } from '@redux/tasks/tasksSelector';
import { ReduxState } from '@redux/types';
import { GeneratingMessageTextArea, GeneratingMessageTextAreaProps } from 'components/GeneratingMessageTextArea/GeneratingMessageTextArea';
import { Text } from 'components/Typography';
import SelectedAssessment from 'containers/Tasks/components/AssessmentArea/SelectedAssessment/SelectedAssessment';
import AssessmentSearch from './AssessmentSearch/AssessmentSearch';

type Props = ConnectedProps<typeof connectRedux> & GeneratingMessageTextAreaProps;

const AssessmentArea: React.FC<Props> = ({ assessment, ...textGeneratingProps }) => {
  return (
    <div>
      <Text variant="md">Assessment</Text>
      {assessment ? (
        <>
          <SelectedAssessment />
          <GeneratingMessageTextArea {...textGeneratingProps} title="Message summary" autoRequest />
        </>
      ) : (
        <AssessmentSearch />
      )}
    </div>
  );
};

const connectRedux = connect(
  (state: ReduxState) => ({
    assessment: getSelectedAssessmentSelector(state)
  }),
  {}
);

export default compose(connectRedux)(AssessmentArea);
